// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICalendarEventPlanDto
 */
export interface ICalendarEventPlanDto {
    /**
     * 
     * @type {string}
     * @memberof ICalendarEventPlanDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICalendarEventPlanDto
     */
    type?: ICalendarEventPlanDtoTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICalendarEventPlanDtoTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the ICalendarEventPlanDto interface.
 */
export function instanceOfICalendarEventPlanDto(value: object): value is ICalendarEventPlanDto {
    return true;
}

export function ICalendarEventPlanDtoFromJSON(json: any): ICalendarEventPlanDto {
    return ICalendarEventPlanDtoFromJSONTyped(json, false);
}

export function ICalendarEventPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICalendarEventPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function ICalendarEventPlanDtoToJSON(json: any): ICalendarEventPlanDto {
    return ICalendarEventPlanDtoToJSONTyped(json, false);
}

export function ICalendarEventPlanDtoToJSONTyped(value?: ICalendarEventPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
    };
}

